var _style, _path, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _defs1, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _polygon283;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdutechLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 506 106",
    style: {
      enableBackground: "new 0 0 506 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000111888634791075790510000007874549565473506482_);fill:url(#SVGID_00000008841940783405296270000002744026896378328742_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000093178368428315013420000015613388492059264930_);fill:url(#SVGID_00000181079857512146354510000001746728981429707172_);}\n\t.st3{opacity:0.53;clip-path:url(#SVGID_00000127031116965532868050000006261893141111354544_);}\n\t.st4{opacity:0.72;clip-path:url(#SVGID_00000064323731036128304030000005032879296236893086_);}\n\t.st5{clip-path:url(#SVGID_00000000202948443552762660000000373029271859364003_);}\n\t.st6{clip-path:url(#SVGID_00000010288070516817820580000015687855198363325342_);}\n\t.st7{clip-path:url(#SVGID_00000114758162759556268940000005906995806216896925_);}\n\t.st8{clip-path:url(#SVGID_00000080190596031758302160000007588048846653205912_);}\n\t.st9{opacity:0.3;clip-path:url(#SVGID_00000155837966057176495820000014789402823077261717_);}\n\t.st10{fill:#FFFFFF;}\n\t.st11{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st12{opacity:0.75;fill:#FFFFFF;enable-background:new    ;}\n\t.st13{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st14{opacity:0.65;fill:#FFFFFF;enable-background:new    ;}\n\t.st15{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st16{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st17{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st18{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st19{opacity:0.45;fill:#FFFFFF;enable-background:new    ;}\n\t.st20{fill:#FFFFFF;fill-opacity:0;}\n\t.st21{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.3248,
    y1: 53.11,
    x2: 67.3956,
    y2: 53.11,
    gradientTransform: "matrix(1 0 0 -1 0 106.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3C4C9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0832,
    style: {
      stopColor: "#3A4999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4042,
    style: {
      stopColor: "#323E91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    style: {
      stopColor: "#2A3887"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#293682"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.86,33.68c-0.48-0.33-0.96-0.65-1.47-0.94c-0.27-0.15-0.55-0.29-0.83-0.44c0.28,0.14,0.56,0.28,0.83,0.44 C81.9,33.04,82.39,33.35,82.86,33.68z M87.09,37.59c0.82,1.01,1.57,2.1,2.21,3.28c1.9,3.47,2.87,7.47,2.87,11.87 c0,4.4-0.96,8.39-2.87,11.87c-0.8,1.45-1.74,2.78-2.8,3.98c1.07-1.2,2.01-2.52,2.81-3.98c1.9-3.47,2.87-7.47,2.87-11.87 c0-4.39-0.96-8.39-2.87-11.86C88.66,39.7,87.91,38.6,87.09,37.59z M39.36,30.19c1.18,0,2.17-0.38,2.96-1.13 c0.79-0.75,1.21-1.75,1.21-2.88c0-1.12-0.41-2.12-1.19-2.9c-0.79-0.79-1.79-1.19-2.98-1.19H3.97c-1.13,0-2.11,0.39-2.92,1.17 c-0.82,0.78-1.25,1.82-1.25,3v53.05c0,1.14,0.41,2.13,1.23,2.94c0.82,0.82,1.8,1.23,2.95,1.23h35.4c1.19,0,2.19-0.4,2.98-1.19 c0.78-0.78,1.19-1.78,1.19-2.9c0-1.14-0.42-2.13-1.21-2.88c-0.79-0.75-1.78-1.13-2.96-1.13H8.15V56.76h22.4 c1.09,0,2.05-0.37,2.84-1.09c0.83-0.77,1.33-1.87,1.33-3c0-1.12-0.41-2.12-1.19-2.9c-0.79-0.79-1.79-1.18-2.98-1.18H8.13V30.19 H39.36z M85.62,26.01c-4.64-2.61-9.98-3.93-15.84-3.93H56.19c-1.18,0-2.19,0.4-2.98,1.18c-0.79,0.79-1.19,1.79-1.19,2.98V79.3 c0,1.19,0.4,2.19,1.19,2.98c0.79,0.79,1.79,1.19,2.98,1.19h13.59c5.87,0,11.2-1.33,15.84-3.93c4.66-2.61,8.33-6.31,10.92-10.96 c2.58-4.64,3.89-9.97,3.89-15.84c0-5.87-1.31-11.19-3.89-15.81C93.95,32.3,90.28,28.63,85.62,26.01z M89.31,64.6 c-0.8,1.45-1.74,2.78-2.81,3.98c-1.47,1.65-3.17,3.06-5.12,4.2c-3.37,1.97-7.27,2.96-11.61,2.96h-9.42V29.81h9.42 c3.99,0,7.61,0.85,10.79,2.49c0.28,0.14,0.56,0.28,0.83,0.44c0.51,0.29,0.99,0.61,1.47,0.94c1.6,1.1,3.01,2.41,4.23,3.91 c0.82,1.01,1.57,2.1,2.22,3.28c1.9,3.47,2.87,7.47,2.87,11.86C92.17,57.13,91.21,61.13,89.31,64.6z M81.38,72.77 c-3.36,1.97-7.27,2.96-11.6,2.96h-9.42V29.81h9.42c3.99,0,7.6,0.85,10.78,2.49c-3.18-1.64-6.79-2.49-10.79-2.49h-9.42v45.93h9.42 C74.11,75.74,78.02,74.74,81.38,72.77c1.95-1.14,3.66-2.55,5.12-4.2C85.04,70.23,83.33,71.64,81.38,72.77z M87.09,37.59 c-1.22-1.5-2.63-2.8-4.23-3.91C84.46,34.79,85.87,36.09,87.09,37.59z M155.13,22.08c-1.19,0-2.19,0.4-2.98,1.19 c-0.79,0.79-1.19,1.79-1.19,2.98v36.53c0,2.66-0.68,5.07-2.03,7.14c-1.36,2.09-3.26,3.75-5.66,4.93c-2.44,1.2-5.28,1.8-8.44,1.8 c-3.22,0-6.11-0.61-8.6-1.8c-2.45-1.18-4.37-2.83-5.73-4.92c-1.34-2.07-2.03-4.48-2.03-7.14V26.25c0-1.18-0.4-2.19-1.19-2.98 c-0.79-0.79-1.79-1.19-2.98-1.19c-1.19,0-2.19,0.4-2.98,1.19s-1.19,1.79-1.19,2.98v36.53c0,4.2,1.07,8.01,3.17,11.33 c2.1,3.33,5.07,5.95,8.84,7.8c3.72,1.83,7.99,2.77,12.69,2.77c4.65,0,8.87-0.93,12.55-2.77c3.71-1.85,6.65-4.48,8.75-7.8 c2.1-3.33,3.17-7.14,3.17-11.33V26.25c0-1.18-0.4-2.19-1.19-2.98C157.33,22.48,156.32,22.08,155.13,22.08z M214.04,23.19 c-0.73-0.72-1.71-1.11-2.83-1.11h-41.73c-1.12,0-2.1,0.39-2.83,1.11c-0.74,0.74-1.12,1.69-1.12,2.83c0,1.07,0.39,2.02,1.11,2.75 c0.74,0.74,1.69,1.12,2.83,1.12h16.66v49.42c0,1.14,0.41,2.13,1.23,2.94c0.8,0.8,1.82,1.23,2.95,1.23c1.27,0,2.37-0.5,3.17-1.44 c0.67-0.8,1-1.84,1-2.88V29.89h16.74c1.14,0,2.09-0.37,2.83-1.11c0.73-0.73,1.12-1.68,1.12-2.75 C215.15,24.9,214.77,23.92,214.04,23.19L214.04,23.19z M260.94,30.19c1.18,0,2.17-0.38,2.96-1.13c0.79-0.75,1.21-1.75,1.21-2.88 c0-1.12-0.41-2.12-1.19-2.9c-0.79-0.79-1.79-1.19-2.98-1.19h-35.4c-1.13,0-2.11,0.39-2.92,1.17c-0.82,0.78-1.25,1.82-1.25,3v53.05 c0,1.14,0.41,2.13,1.23,2.94c0.82,0.82,1.8,1.23,2.95,1.23h35.4c1.19,0,2.19-0.4,2.98-1.19c0.78-0.78,1.19-1.78,1.19-2.9 c0-1.14-0.42-2.13-1.21-2.88c-0.79-0.75-1.78-1.13-2.96-1.13h-31.23V56.76h22.4c1.09,0,2.05-0.37,2.84-1.09 c0.83-0.77,1.33-1.87,1.33-3c0-1.12-0.41-2.12-1.19-2.9c-0.79-0.79-1.79-1.18-2.98-1.18h-22.4V30.19H260.94z M290.19,32.53 c3.41-2.1,7.15-3.18,11.13-3.18c2.91,0,5.5,0.38,7.68,1.14c2.15,0.75,4.17,1.96,5.99,3.6c0.73,0.66,1.64,0.99,2.71,0.99 c0.61,0,1.2-0.15,1.74-0.47c0.45-0.26,0.8-0.6,1.02-1.02c0.37-0.24,0.67-0.56,0.92-0.95c0.32-0.52,0.48-1.1,0.48-1.74 c0-1.15-0.46-2.09-1.27-2.68c-2.87-2.4-5.88-4.17-8.98-5.27c-3.09-1.1-6.55-1.66-10.3-1.66c-5.58,0-10.77,1.43-15.42,4.25 c-4.64,2.82-8.36,6.67-11.07,11.46c-2.71,4.79-4.08,10.07-4.08,15.69c0,5.68,1.39,10.98,4.12,15.77 c2.73,4.79,6.47,8.65,11.11,11.46c4.65,2.82,9.82,4.25,15.35,4.25c7.88,0,14.38-2.29,19.31-6.81l0.07-0.07 c0.77-0.83,1.15-1.82,1.15-2.94c0-1.18-0.42-2.2-1.21-2.96c-0.79-0.75-1.73-1.13-2.8-1.13c-0.82,0-1.61,0.28-2.42,0.87 c-4.18,3.33-8.93,5.02-14.11,5.02c-4.03,0-7.8-1.06-11.21-3.14c-3.42-2.09-6.17-4.96-8.17-8.53c-2-3.57-3.01-7.53-3.01-11.78 c0-4.14,1.02-8.06,3.05-11.62C283.99,37.54,286.76,34.65,290.19,32.53z M378.8,22.08c-0.86-0.02-1.73,0.21-2.44,0.69 c-1.2,0.81-1.84,2.04-1.84,3.48v22.32h-34.38V26.25c0-1.18-0.4-2.19-1.19-2.98c-0.79-0.79-1.79-1.19-2.98-1.19 c-1.13,0-2.11,0.39-2.92,1.17c-0.82,0.78-1.25,1.82-1.25,3V79.3c0,1.14,0.41,2.13,1.23,2.94c0.82,0.82,1.8,1.23,2.95,1.23 c1.27,0,2.37-0.5,3.17-1.44c0.67-0.8,1-1.84,1-2.88V56.3h34.38v23c0,1.12,0.42,2.14,1.23,2.94c0.82,0.82,1.8,1.23,2.95,1.23 c1.27,0,2.37-0.5,3.17-1.44c0.67-0.8,1-1.84,1-2.88v-52.9c0-1.18-0.4-2.19-1.19-2.98C380.89,22.5,379.94,22.1,378.8,22.08z  M446.1,30.26l-47.37,0.01v-8.18h18.89h22.54L446.1,30.26z M446.1,75.34l-47.37-0.01v8.18h18.89h22.54L446.1,75.34z M505.57,83.52 h-10.57L481.9,66.68l5.28-6.78L505.57,83.52z M495.63,22.08l-13.68,17.56l5.28,6.78l18.96-24.35L495.63,22.08L495.63,22.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000013915929671253535160000013827662286595859856_",
    points: "460.82,22.08 446.1,22.08 467.17,49.13  398.72,49.13 398.72,49.13 398.72,49.13 398.72,57.31 398.72,57.31 398.72,57.32 467.13,57.32 446.73,83.52 461.45,83.52  485.17,53.35  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138571000482172590390000014096635670066568839_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013915929671253535160000013827662286595859856_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150780857807558803770000006955948409536534410_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.2313,
    y1: 79.1373,
    x2: 482.5292,
    y2: 50.4227,
    gradientTransform: "matrix(1 0 0 -1 0 106.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#64C5E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#12A480"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000138571000482172590390000014096635670066568839_)",
      fill: "url(#SVGID_00000150780857807558803770000006955948409536534410_)"
    },
    points: " 487.63,53.29 386.53,53.29 422.93,15.96 456.3,15.96  "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000132053237078163464960000016005162936929549755_",
    points: "460.82,22.08 446.1,22.08 467.17,49.13  398.72,49.13 398.72,49.13 398.72,49.13 398.72,57.31 398.72,57.31 398.72,57.32 467.13,57.32 446.73,83.52 461.45,83.52  485.17,53.35  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132767415016407833280000011237859428716072610_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132053237078163464960000016005162936929549755_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019680336005962058350000017604941982906739861_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.7112,
    y1: 33.835,
    x2: 398.4133,
    y2: 34.8698,
    gradientTransform: "matrix(1 0 0 -1 0 106.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#64C5E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28718D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000132767415016407833280000011237859428716072610_)",
      fill: "url(#SVGID_00000019680336005962058350000017604941982906739861_)"
    },
    points: " 422.93,90.61 456.3,90.61 487.63,53.29 391.86,53.29  "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000025413423710175376930000003765022449440899494_",
    points: "460.82,22.08 446.1,22.08 467.17,49.13  398.72,49.13 398.72,49.13 398.72,49.13 398.72,57.31 398.72,57.31 398.72,57.32 467.13,57.32 446.73,83.52 461.45,83.52  485.17,53.35  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148646201004468337300000002609779361335070881_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025413423710175376930000003765022449440899494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.53,
      clipPath: "url(#SVGID_00000148646201004468337300000002609779361335070881_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000112599388017829676550000006940652815859357097_",
    d: "M422.93,90.61c0,0,37.76-37.32,64.69-37.32 L456.3,90.61H422.93z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065068751808200847860000001663489074779536545_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112599388017829676550000006940652815859357097_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000106829678777908304400000009175062732340880276_",
    points: "460.82,22.08 446.1,22.08 467.17,49.13  398.72,49.13 398.72,49.13 398.72,49.13 398.72,57.31 398.72,57.31 398.72,57.32 467.13,57.32 446.73,83.52 461.45,83.52  485.17,53.35  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029758779935476857100000001984339401956442795_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106829678777908304400000009175062732340880276_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72,
      clipPath: "url(#SVGID_00000029758779935476857100000001984339401956442795_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085216121459093302550000005059473036914762935_",
    d: "M422.93,15.96c0,0,37.76,37.32,64.69,37.32 L456.3,15.96C456.3,15.96,422.93,15.96,422.93,15.96z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137843949768549078900000002522538476316567722_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085216121459093302550000005059473036914762935_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137843949768549078900000002522538476316567722_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152946132505784982000000012299721168927260289_",
    x: 458.12,
    y: -14.36,
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 335.4965 488.4351)",
    width: 54.07,
    height: 81.11
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003801958653847975640000004133034390263837366_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152946132505784982000000012299721168927260289_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003801958653847975640000004133034390263837366_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000123401233903078399820000013959808547403771294_",
    x: 458.15,
    y: -14.44,
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 335.5349 488.4519)",
    width: 54.07,
    height: 81.23
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059292987859199788550000013782295330204552332_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123401233903078399820000013959808547403771294_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000059292987859199788550000013782295330204552332_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070820123462610744700000000309074836124983695_",
    x: 457.61,
    y: -14.98,
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 335.5281 488.455)",
    width: 55.15,
    height: 82.31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085222435785267668470000015955898405280622470_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070820123462610744700000000309074836124983695_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085222435785267668470000015955898405280622470_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119811018456668910730000013838714788519894145_",
    x: 457.61,
    y: -14.98,
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 335.528 488.455)",
    width: 55.15,
    height: 82.31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003077101469260039330000016020731730429385914_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119811018456668910730000013838714788519894145_",
    style: {
      overflow: "visible"
    }
  })))))))))), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183245456158740297340000005041262169084806302_",
    x: 458.12,
    y: -14.36,
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 335.4965 488.4351)",
    width: 54.07,
    height: 81.11
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090279488554400153750000007488969150915788173_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183245456158740297340000005041262169084806302_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000090279488554400153750000007488969150915788173_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "458.38,-9.97 452.36,-8.34 453.96,-14.37  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "468.83,-7.2 462.81,-5.57 464.4,-11.6  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "464.4,-11.6 462.81,-5.57 458.38,-9.97  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "479.28,-4.43 472.06,-3.27 474.85,-8.83  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "474.85,-8.83 472.06,-3.27 468.83,-7.2  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "489.73,-1.66 485.42,-2.26 485.3,-6.06  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "485.3,-6.06 485.42,-2.26 479.28,-4.43  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "500.17,1.11 494.66,4.47 495.74,-3.29  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "495.74,-3.29 494.66,4.47 489.73,-1.66  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "506.19,-0.52 502.93,6.66 500.17,1.11  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "458.38,-9.97 454.03,-4.08 452.36,-8.34  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "462.81,-5.57 461.21,0.46 454.03,-4.08  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "462.81,-5.57 454.03,-4.08 458.38,-9.97  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "461.21,0.46 455.19,2.09 454.03,-4.08  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "454.03,-4.08 455.19,2.09 450.76,-2.31  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "454.03,-4.08 450.76,-2.31 452.36,-8.34  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "468.83,-7.2 465.56,0.46 462.81,-5.57  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "472.07,-3.28 471.66,3.23 465.56,0.46  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "472.07,-3.28 465.56,0.46 468.83,-7.2  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "471.66,3.23 465.63,4.86 465.56,0.46  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "465.56,0.46 465.63,4.86 461.21,0.46  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "465.56,0.46 461.21,0.46 462.81,-5.57  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "479.28,-4.43 479.45,1.75 472.07,-3.28  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "485.42,-2.27 484.21,6.56 479.45,1.75  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "485.42,-2.27 479.45,1.75 479.28,-4.43  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "484.21,6.56 476.08,7.63 479.45,1.75  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "479.45,1.75 476.08,7.63 471.66,3.23  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "479.45,1.75 471.66,3.23 472.07,-3.28  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "489.72,-1.66 488.12,4.37 485.42,-2.27  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "494.66,4.47 491.09,8.38 488.12,4.37  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "494.66,4.47 488.12,4.37 489.72,-1.66  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "491.09,8.38 486.52,10.4 488.12,4.37  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "488.12,4.37 486.52,10.4 484.21,6.56  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "488.12,4.37 484.21,6.56 485.42,-2.27  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "500.17,1.11 498.57,7.14 494.66,4.47  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "502.93,6.66 503,11.53 498.57,7.14  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "502.93,6.66 498.57,7.14 500.17,1.11  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "503,11.53 498.54,11.4 498.57,7.14  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "498.57,7.14 498.54,11.4 491.09,8.38  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "498.57,7.14 491.09,8.38 494.66,4.47  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "455.19,2.09 453.59,8.12 447.7,2.95  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "455.19,2.09 447.7,2.95 450.76,-2.31  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "453.59,8.12 447.56,9.75 447.7,2.95  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "461.21,0.46 458.14,7.72 455.19,2.09  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "465.63,4.86 464.62,8.67 458.14,7.72  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "465.63,4.86 458.14,7.72 461.21,0.46  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "464.62,8.67 456.39,14.32 458.14,7.72  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "458.14,7.72 456.39,14.32 453.59,8.12  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "458.14,7.72 453.59,8.12 455.19,2.09  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "471.66,3.23 471.01,11.39 465.63,4.86  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "476.08,7.62 474.48,13.66 471.01,11.39  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "476.08,7.62 471.01,11.39 471.66,3.23  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "474.48,13.66 468.46,15.29 471.01,11.39  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "471.01,11.39 468.46,15.29 464.62,8.67  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "471.01,11.39 464.62,8.67 465.63,4.86  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "484.2,6.56 478.8,14.04 476.08,7.62  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "486.52,10.4 486.23,15.17 478.8,14.04  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "486.52,10.4 478.8,14.04 484.2,6.56  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "486.23,15.17 478.9,18.06 478.8,14.04  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "478.8,14.04 478.9,18.06 474.48,13.66  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "478.8,14.04 474.48,13.66 476.08,7.62  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "491.09,8.38 490.95,14.8 486.52,10.4  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "498.54,11.4 494.63,20.55 490.95,14.8  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "498.54,11.4 490.95,14.8 491.09,8.38  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "494.63,20.55 486.4,22.28 490.95,14.8  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "490.95,14.8 486.4,22.28 486.23,15.17  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "490.95,14.8 486.23,15.17 486.52,10.4  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "502.99,11.54 501.39,17.56 498.54,11.4  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "501.39,17.56 500.28,25.95 494.63,20.55  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "501.39,17.56 494.63,20.55 498.54,11.4  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "453.59,8.12 451.99,14.15 447.57,9.75  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "456.39,14.32 456.42,18.55 451.99,14.15  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "456.39,14.32 451.99,14.15 453.59,8.12  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "456.42,18.55 448.68,21.25 451.99,14.15  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "451.99,14.15 448.68,21.25 445.97,15.78  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "451.99,14.15 445.97,15.78 447.57,9.75  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "464.62,8.67 463.91,15.74 456.39,14.32  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "468.46,15.29 466.85,23.2 463.91,15.74  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "468.46,15.29 463.91,15.74 464.62,8.67  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "466.85,23.2 457.65,22.1 463.91,15.74  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "463.91,15.74 457.65,22.1 456.42,18.55  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "463.91,15.74 456.42,18.55 456.39,14.32  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "474.48,13.66 474.91,17.8 468.46,15.29  "
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "478.9,18.05 477.31,24.09 474.91,17.8  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "478.9,18.05 474.91,17.8 474.48,13.66  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "477.31,24.09 471.28,25.72 474.91,17.8  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "474.91,17.8 471.28,25.72 466.85,23.2  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "474.91,17.8 466.85,23.2 468.46,15.29  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "486.23,15.17 481.36,21.17 478.9,18.05  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "486.4,22.28 487.75,26.85 481.36,21.17  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "486.4,22.28 481.36,21.17 486.23,15.17  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "487.75,26.85 483.1,26.95 481.36,21.17  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "481.36,21.17 483.1,26.95 477.31,24.09  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "481.36,21.17 477.31,24.09 478.9,18.05  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "494.63,20.55 493.77,25.23 486.4,22.28  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "500.28,25.95 498.2,29.63 493.77,25.23  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "500.28,25.95 493.77,25.23 494.63,20.55  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "498.2,29.63 494.79,31.95 493.77,25.23  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "493.77,25.23 494.79,31.95 487.75,26.85  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "493.77,25.23 487.75,26.85 486.4,22.28  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "448.68,21.25 446.38,26.69 444.26,18.55  "
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "448.68,21.25 444.26,18.55 445.97,15.78  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "446.38,26.69 440.1,24.74 444.26,18.55  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "456.41,18.55 454.81,24.58 448.68,21.25  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "457.65,22.1 458.21,30.15 454.81,24.58  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "457.65,22.1 454.81,24.58 456.41,18.55  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "458.21,30.15 453.21,30.61 454.81,24.58  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "454.81,24.58 453.21,30.61 446.38,26.69  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "454.81,24.58 446.38,26.69 448.68,21.25  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "466.85,23.2 464.51,28.84 457.65,22.1  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "471.28,25.72 471.17,29.95 464.51,28.84  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "471.28,25.72 464.51,28.84 466.85,23.2  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "471.17,29.95 463.36,34.5 464.51,28.84  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "464.51,28.84 463.36,34.5 458.21,30.15  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "464.51,28.84 458.21,30.15 457.65,22.1  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "477.31,24.09 475.71,30.12 471.28,25.72  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "483.1,26.95 480.56,36.55 475.71,30.12  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "483.1,26.95 475.71,30.12 477.31,24.09  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "480.56,36.55 475.91,37.83 475.71,30.12  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "475.71,30.12 475.91,37.83 471.17,29.95  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "475.71,30.12 471.17,29.95 471.28,25.72  "
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "487.75,26.86 487.84,32.23 483.1,26.95  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "494.79,31.95 490.58,37.28 487.84,32.23  "
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "494.79,31.95 487.84,32.23 487.75,26.86  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "490.58,37.28 484.55,38.92 487.84,32.23  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "487.84,32.23 484.55,38.92 480.56,36.55  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "487.84,32.23 480.56,36.55 483.1,26.95  "
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "498.2,29.63 496.6,35.66 494.79,31.95  "
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "496.6,35.66 496.93,40.09 490.58,37.28  "
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "496.6,35.66 490.58,37.28 494.79,31.95  "
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "446.38,26.69 447.19,32.24 440.1,24.74  "
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "453.22,30.61 453.54,37.62 447.19,32.24  "
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "453.22,30.61 447.19,32.24 446.38,26.69  "
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "453.54,37.62 443.62,38.19 447.19,32.24  "
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "447.19,32.24 443.62,38.19 441.17,33.87  "
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "447.19,32.24 441.17,33.87 440.1,24.74  "
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "458.21,30.15 457.64,35.01 453.22,30.61  "
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "463.37,34.5 462.56,41.55 457.64,35.01  "
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "463.37,34.5 457.64,35.01 458.21,30.15  "
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "462.56,41.55 456.04,41.04 457.64,35.01  "
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "457.64,35.01 456.04,41.04 453.54,37.62  "
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "457.64,35.01 453.54,37.62 453.22,30.61  "
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "471.17,29.95 469.13,37.63 463.37,34.5  "
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "475.91,37.83 472.51,42.17 469.13,37.63  "
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "475.91,37.83 469.13,37.63 471.17,29.95  "
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "472.51,42.17 466.48,43.81 469.13,37.63  "
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "469.13,37.63 466.48,43.81 462.56,41.55  "
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "469.13,37.63 462.56,41.55 463.37,34.5  "
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "480.56,36.55 478.53,40.55 475.91,37.83  "
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "484.55,38.92 484.88,43.41 478.53,40.55  "
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "484.55,38.92 478.53,40.55 480.56,36.55  "
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "484.88,43.41 479.07,46.9 478.53,40.55  "
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "478.53,40.55 479.07,46.9 472.51,42.17  "
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "478.53,40.55 472.51,42.17 475.91,37.83  "
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "490.58,37.28 488.98,43.32 484.55,38.92  "
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "496.93,40.09 493.4,47.71 488.98,43.32  "
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "496.93,40.09 488.98,43.32 490.58,37.28  "
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "493.4,47.71 487.38,49.35 488.98,43.32  "
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "488.98,43.32 487.38,49.35 484.88,43.41  "
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "488.98,43.32 484.88,43.41 484.55,38.92  "
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "443.62,38.19 444,44.3 439.57,39.9  "
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "443.62,38.19 439.57,39.9 441.17,33.87  "
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "444,44.3 437.97,45.93 439.57,39.9  "
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "453.54,37.62 450.02,42.67 443.62,38.19  "
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "456.04,41.04 454.45,47.07 450.02,42.67  "
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "456.04,41.04 450.02,42.67 453.54,37.62  "
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "454.45,47.07 448.42,48.7 450.02,42.67  "
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "450.02,42.67 448.42,48.7 444,44.3  "
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "450.02,42.67 444,44.3 443.62,38.19  "
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "462.55,41.55 460.46,45.44 456.04,41.04  "
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "466.49,43.81 464.89,49.84 460.46,45.44  "
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "466.49,43.81 460.46,45.44 462.55,41.55  "
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "464.89,49.84 458.86,51.47 460.46,45.44  "
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "460.46,45.44 458.86,51.47 454.45,47.07  "
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "460.46,45.44 454.45,47.07 456.04,41.04  "
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "510.67,3.89 502.99,6.68 506.24,-0.51  "
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "521.11,6.66 515.09,8.29 516.69,2.26  "
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "516.69,2.26 515.09,8.29 510.67,3.89  "
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "531.56,9.43 525.54,11.06 527.13,5.03  "
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "527.13,5.03 525.54,11.06 521.11,6.66  "
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "510.67,3.89 509.07,9.92 502.99,6.67  "
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "515.1,8.29 512.58,15.34 509.07,9.92  "
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "515.1,8.29 509.07,9.92 510.67,3.89  "
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "512.58,15.34 507.47,15.95 509.07,9.92  "
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "509.07,9.92 507.47,15.95 503.05,11.55  "
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "509.07,9.92 503.05,11.55 502.99,6.67  "
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "521.11,6.66 519.51,12.69 515.1,8.29  "
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "525.54,11.06 523.94,17.09 519.51,12.69  "
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "525.54,11.06 519.51,12.69 521.11,6.66  "
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "523.94,17.09 520.1,19.3 519.51,12.69  "
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "519.51,12.69 520.1,19.3 512.58,15.34  "
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "519.51,12.69 512.58,15.34 515.1,8.29  "
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "531.56,9.43 529.96,15.46 525.54,11.06  "
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "529.96,15.46 528.36,21.49 523.94,17.09  "
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "529.96,15.46 523.94,17.09 525.54,11.06  "
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "507.48,15.95 508.19,22.6 501.45,17.58  "
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "507.48,15.95 501.45,17.58 503.05,11.55  "
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "508.19,22.6 500.33,25.96 501.45,17.58  "
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "512.58,15.34 511.89,20.35 507.48,15.95  "
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "520.1,19.3 516.32,24.75 511.89,20.35  "
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "520.1,19.3 511.89,20.35 512.58,15.34  "
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "516.32,24.75 510.3,26.38 511.89,20.35  "
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "511.89,20.35 510.3,26.38 508.19,22.6  "
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "511.89,20.35 508.19,22.6 507.48,15.95  "
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "523.94,17.09 522.34,23.12 520.1,19.3  "
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "528.37,21.49 526.77,27.52 522.34,23.12  "
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "528.37,21.49 522.34,23.12 523.94,17.09  "
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "526.77,27.52 522.69,29.67 522.34,23.12  "
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "522.34,23.12 522.69,29.67 516.32,24.75  "
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "522.34,23.12 516.32,24.75 520.1,19.3  "
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "508.18,22.6 504.27,28.01 500.33,25.96  "
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "510.3,26.38 508.7,32.41 504.27,28.01  "
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "510.3,26.38 504.27,28.01 508.18,22.6  "
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "508.7,32.41 502.68,34.04 504.27,28.01  "
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "504.27,28.01 502.68,34.04 498.25,29.64  "
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "504.27,28.01 498.25,29.64 500.33,25.96  "
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "516.32,24.75 514.57,28.28 510.3,26.38  "
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "522.69,29.66 519.15,35.18 514.57,28.28  "
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "522.69,29.66 514.57,28.28 516.32,24.75  "
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "519.15,35.18 514.73,34.58 514.57,28.28  "
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "514.57,28.28 514.73,34.58 508.7,32.41  "
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "514.57,28.28 508.7,32.41 510.3,26.38  "
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "526.77,27.52 525.16,33.55 522.69,29.66  "
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "525.16,33.55 523.57,39.58 519.15,35.18  "
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "525.16,33.55 519.15,35.18 522.69,29.66  "
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "502.68,34.04 501.08,40.07 496.65,35.67  "
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "502.68,34.04 496.65,35.67 498.25,29.64  "
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "501.08,40.07 496.98,40.11 496.65,35.67  "
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "508.7,32.41 506.08,39.85 502.68,34.04  "
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "514.73,34.58 511.52,42.84 506.08,39.85  "
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "514.73,34.58 506.08,39.85 508.7,32.41  "
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "511.52,42.84 505.5,44.47 506.08,39.85  "
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "506.08,39.85 505.5,44.47 501.08,40.07  "
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "506.08,39.85 501.08,40.07 502.68,34.04  "
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "519.15,35.18 515.55,43.36 514.73,34.58  "
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "523.57,39.58 521.97,45.61 515.55,43.36  "
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "523.57,39.58 515.55,43.36 519.15,35.18  "
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "521.97,45.61 515.95,47.24 515.55,43.36  "
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "515.55,43.36 515.95,47.24 511.52,42.84  "
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "515.55,43.36 511.52,42.84 514.73,34.58  "
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "501.08,40.07 499.48,46.1 496.99,40.11  "
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "505.5,44.47 503.9,50.5 499.48,46.1  "
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "505.5,44.47 499.48,46.1 501.08,40.07  "
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "503.9,50.5 496.69,52.82 499.48,46.1  "
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "499.48,46.1 496.69,52.82 493.46,47.73  "
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "499.48,46.1 493.46,47.73 496.99,40.11  "
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "511.52,42.84 507.39,49.8 505.5,44.47  "
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "515.95,47.24 512.38,52.54 507.39,49.8  "
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "515.95,47.24 507.39,49.8 511.52,42.84  "
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "512.38,52.54 508.33,54.9 507.39,49.8  "
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "507.39,49.8 508.33,54.9 503.9,50.5  "
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "507.39,49.8 503.9,50.5 505.5,44.47  "
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "521.97,45.61 520.37,51.64 515.95,47.24  "
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "520.37,51.64 518.77,57.67 512.38,52.54  "
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "520.37,51.64 512.38,52.54 515.95,47.24  "
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "496.7,52.82 496.28,58.16 490.17,53.32  "
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "496.7,52.82 490.17,53.32 493.46,47.73  "
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "496.28,58.16 490.26,59.79 490.17,53.32  "
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "503.9,50.5 503.91,55.14 496.7,52.82  "
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "508.33,54.9 506.73,60.93 503.91,55.14  "
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "508.33,54.9 503.91,55.14 503.9,50.5  "
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "506.73,60.93 500.71,62.56 503.91,55.14  "
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "503.91,55.14 500.71,62.56 496.28,58.16  "
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "503.91,55.14 496.28,58.16 496.7,52.82  "
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "512.38,52.54 512.75,59.3 508.33,54.9  "
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "518.77,57.67 517.18,63.7 512.75,59.3  "
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "518.77,57.67 512.75,59.3 512.38,52.54  "
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "517.18,63.7 511.15,65.33 512.75,59.3  "
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "512.75,59.3 511.15,65.33 506.73,60.93  "
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "512.75,59.3 506.73,60.93 508.33,54.9  "
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "472.51,42.17 472.9,46.92 466.49,43.81  "
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "479.07,46.9 475.34,52.6 472.9,46.92  "
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "479.07,46.9 472.9,46.92 472.51,42.17  "
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "475.34,52.6 469.31,54.24 472.9,46.92  "
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "472.9,46.92 469.31,54.24 464.89,49.84  "
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "472.9,46.92 464.89,49.84 466.49,43.81  "
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "484.87,43.41 481.36,50.98 479.07,46.9  "
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "487.38,49.35 485.78,55.38 481.36,50.98  "
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "487.38,49.35 481.36,50.98 484.87,43.41  "
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "485.78,55.38 479.75,57 481.36,50.98  "
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "481.36,50.98 479.75,57 475.34,52.6  "
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "481.36,50.98 475.34,52.6 479.07,46.9  "
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "493.4,47.71 490.12,53.3 487.38,49.35  "
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "490.12,53.3 490.2,59.78 485.78,55.38  "
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "490.12,53.3 485.78,55.38 487.38,49.35  "
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdutechLogo);
export default __webpack_public_path__ + "static/media/Edutech-logo.3b488aa5a40f6193d510f5eaff54f376.svg";
export { ForwardRef as ReactComponent };